<template>
	<div class="setpercent">
		<el-dialog :visible.sync="showpercent" :title="title" width="500px" :close-on-click-modal="false" lock-scroll :show-close="true" :append-to-body="true">
			<el-row style="height:150px;">
				<el-col :span="4" style="color:transparent;">
					1
				</el-col>
				<el-col :span="3" style="padding-top:3px">
					<span>提成比例</span>
				</el-col>
				<el-col :span="1" style="color:transparent">1</el-col>
				<el-col :span="12">
					<el-input type="number" ref="percent"  size="mini" v-model="percent" @input="changeinput">
						 <template slot="append">%</template>
					</el-input>
				</el-col>
			</el-row>
			<span slot="footer" class="dialog-footer">
				<el-row>
					<el-col :span="9" style="color:transparent;">
						1
					</el-col>
					<el-col :span="4" style="text-align:center;"><el-button @click="sure" size="mini" type="success" :disabled="btndisabled">确定</el-button></el-col>
					<el-col :span="3" style="text-align:center;"><el-button @click="cancel" size="mini" >取消</el-button></el-col>
					<!-- <el-col :span="9" style="text-align:right;">
						1
					</el-col> -->
				</el-row>
			</span>
		</el-dialog>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		
	},
	data() {
		return {
			showpercent:false,
			percent:0,
			batch:'',
			pageparam:{},
			btndisabled:true,
			title:'设置提成比例'
		};
	},
	mounted() {
		
	},
	methods:{
		init(param){
			if(param.batch!=undefined)
				this.batch=param.batch;
			if(param.pageparam!=undefined)
				this.pageparam=param.pageparam;
			this.showpercent=true;
			var that=this;
			setTimeout(function(){
				 that.$refs["percent"].focus();
			},200);
		},
		changeinput(){
			if(this.percent>0)
				this.btndisabled=false;
			else
				this.btndisabled=true;
		},
		//保存提成比例
		sure(){
			var that=this;
			this.$apipost.post.UpdatePerCent({ paraminfo:this._data}).then(res => {
				if(res.state=='1'){
					this.$tool.message(res.message, 1);
					setTimeout(function(){
						that.cancel();
					},1500);
				}else
					this.$tool.message(res.message, 0);
			});
		},
		cancel(){
			this.showpercent=false;
		}
	}
}
</script>

<style>
</style>
